module.exports = __webpack_public_path__ + "static/media/noe-lamp-img2.ec67a30a.jpg";